<template>
  <div class="checkbox-group">
    <div
      v-for="option in options"
      :key="option.value"
      :class="modelValue.includes(option.value) ? 'bg-[#E8DCC766] border-[2px]' : ''"
      class="flex items-center cursor-pointer mb-[8px] p-[12px] md:p-[16px] rounded-[10px] border-[1px] border-solid border-[#A5A4A3]"
      @click="toggleOption(option.value)"
    >
      <div
        class="w-[20px] h-[20px] md:w-[24px] md:h-[24px] flex items-center justify-center mr-3 md:mr-4"
      >
        <img
          v-if="modelValue.includes(option.value)"
          src="/assets/icons/calendar/checkboxfill.svg"
          alt=""
        />
        <img v-else src="/assets/icons/calendar/checkbox.svg" alt="" />
      </div>
      <label
        class="text-[1rem] md:text-[1.125rem] lg:text-[1.25rem] leading-[1.5rem] md:leading-[1.75rem] font-inter text-[#3C3A36] font-medium select-none !mb-0"
        :class="{ '!font-bold': modelValue.includes(option.value) }"
      >
        {{ option.label }}
      </label>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  modelValue: {
    type: Array,
    required: true,
  },
  options: {
    type: Array,
    required: true,
    validator: value => {
      return value.every(
        option =>
          Object.prototype.hasOwnProperty.call(option, 'value') &&
          Object.prototype.hasOwnProperty.call(option, 'label'),
      );
    },
  },
});

const emit = defineEmits(['update:modelValue']);

const toggleOption = value => {
  const newValue = [...props.modelValue];
  const index = newValue.indexOf(value);

  if (index === -1) {
    newValue.push(value);
  } else {
    newValue.splice(index, 1);
  }

  emit('update:modelValue', newValue);
};
</script>
